import rootReducer from '../reducers'
import { legacy_createStore as createStore } from 'redux';
import { loadState, saveState } from 'state/store/localStorage'

const persistedState = loadState()

const initialState = {
    loading: true,
    auth: false,
    ready: false,
    mobile: false,
    mobile_menu: false,
    content: [],
    backToMrkt: false,
    filters: null,
    mrktPaginate: null,
    user: {},
    simplePopup: null,
    role: 'CLIENT',
    homeContent: [],
    headerContent: [],
    plan: false,
    plans: {
        prices: {},
        list: []
    },
    plansDetails: [],
    cart: [],
    checkout_cart: {},
    checkout_order: {},
    checkout_tab: 1,
    routes: [],
    lang: "en"
}

/* eslint-disable no-underscore-dangle */
const store = createStore(rootReducer,
    { ...initialState, ...persistedState },
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

store.subscribe(() => {
    saveState({
        cart: store.getState().cart,
        checkout_tab: store.getState().checkout_tab,
        checkout_cart: store.getState().checkout_cart,
        checkout_order: store.getState().checkout_order
    })
})

/* eslint-enable */
export default store
